module.exports = __webpack_public_path__ + "static/media/mobiel_bg_looking.f01dad10.mp4";